import { EDITOR, READ_ONLY } from 'utils/access-control/roles';
import { usePermissions } from 'utils/usePermissions';

export const useCanViewSchedule = () => {
  const { hasRole } = usePermissions();

  return hasRole(EDITOR) || hasRole(READ_ONLY);
};
